<template>
  <nav class="navbar navbar-expand-lg">
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarTogglerDemo01"
      aria-controls="navbarTogglerDemo01"
      aria-expanded="false"
      aria-label="Toggle navigation"
      @click="showMenu = !showMenu"
    >
      <span class="navbar-toggler-icon text-white"
        ><i class="fa fa-bars"></i
      ></span>
    </button>
    <div
      class="collapse navbar-collapse  px-md-3"
      id="navbarTogglerDemo01"
      :class="{ 'd-flex': showMenu }"
    >
      <a class="navbar-brand" href="#"
        ><router-link class="nav-item" :to="'/'">
          <img
            :src="require('@/assets/img/shinkanote_logo.svg')"
            width="160"
            height="45"
          />
        </router-link>
      </a>
      <span class="badge badge-primary">BETA</span>

      <ul class="navbar-nav my-2 my-lg-0 d-flex justify-content-end flex-fill">
        <li class="nav-item">
          <router-link class="nav-link" :to="'/login'">Login</router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import useLogout from "@/composables/useLogout";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      showMenu: false
    };
  },
  computed: {
    ...mapGetters({
      editor: "getEditor",
      user: "getUser"
    })
  },
  methods: {
    async logout() {
      const { logout } = useLogout();
      try {
        await logout();
        this.$router.push("/login");
      } catch (e) {
        console.error(e);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
